import "./StateReportingDetailsComponent.scss";

import {useParams} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import CommonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ITableColumn} from "../../../shared/models/table.model";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import {APIConfig, ImageConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import CopyComponent from "../../../shared/components/copyComponent/copyComponent";
import commonService from "../../../shared/services/common.service";

interface StateReportingDetailsComponentProps {

}

const StateReportingDetailsComponent = (props: StateReportingDetailsComponentProps) => {

    const {sessionID} = useParams();
    const [stateReportingSessionDetails, setStateReportingSessionDetails] = useState<any | undefined>(undefined);
    const [isStateReportingSessionDetailsLoading, setIsStateReportingSessionDetailsLoading] = useState<boolean>(false);
    const [isStateReportingSessionDetailsLoaded, setIsStateReportingSessionDetailsLoaded] = useState<boolean>(false);
    const [isStateReportingSessionDetailsLoadingFailed, setIsStateReportingSessionDetailsLoadingFailed] = useState<boolean>(false);
    const [showLogsPreviewDialog, setShowLogsPreviewDialog] = useState<boolean>(false);
    const [sessionData, setSessionData] = useState<any>(undefined);

    const dispatch = useDispatch();

    useEffect(() => {
        if (sessionID) {
            dispatch(setCurrentNavParams("Back", "State Reporting", CommonService._routeConfig.StateReportingListRoute()));
            dispatch(setSideMenuView('compact'));
        }
    }, [sessionID, dispatch]);


    const getSendOutSessionDetails = useCallback(() => {
        setIsStateReportingSessionDetailsLoading(true);
        setIsStateReportingSessionDetailsLoaded(false);
        setIsStateReportingSessionDetailsLoadingFailed(false);
        CommonService._test.getStateReportDetails(sessionID)
            .then((response: IAPIResponseType<any>) => {
                setStateReportingSessionDetails(response.data);
                setIsStateReportingSessionDetailsLoading(false);
                setIsStateReportingSessionDetailsLoaded(true);
                setIsStateReportingSessionDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setStateReportingSessionDetails(undefined);
                setIsStateReportingSessionDetailsLoading(false);
                setIsStateReportingSessionDetailsLoaded(false);
                setIsStateReportingSessionDetailsLoadingFailed(true);
            });
    }, [sessionID]);

    useEffect(() => {
        getSendOutSessionDetails();
    }, [sessionID, getSendOutSessionDetails]);

    const Columns: ITableColumn[] = [
        {id: 'attempt', label: 'Attempt No', isDefaultColumn: true,fixed:"left",align:"center"},
        {
            id: 'reportingTime', label: 'Report Date & Time',
            isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                <>
                    {
                        item.reportingTime ?
                            <>
                                {commonService.formatDate(item?.reportingTime)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.reportingTime)} <br/>
                            </> : <> - </>
                    }
                </>

            )
        },
        {
            id: 'reason', label: 'Issue', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {
                        item?.reason
                    }
                </>
            )
        },
        {
            id: 'status', label: 'Status', isDefaultColumn: true, width: '150', align: 'center',
            content: (item: any) => (
                <ChipComponent className={`min-width-60 ${item?.status}`}
                               label={CommonService.capitalizeFirstLetter(item?.status)}
                               variant={'outlined'}/>
            )
        },

        {
            id: 'actions', label: '', sortable: false, isDefaultColumn: true, align: 'center',fixed:"right",
            content: (item: any) => (
                <ButtonComponent
                    color={'secondary'}
                    variant={'outlined'}
                    size={"small"}
                    startIcon={<RemoveRedEyeIcon/>}
                    handleClick={() => {
                        setSessionData(item);
                        setShowLogsPreviewDialog(true)
                    }}
                >View Issue</ButtonComponent>
            )
        },

    ];


    return (
        <div className={'state-reporting-details-component view-screen'}>
            <div className="view-details-wrapper">
                {
                    isStateReportingSessionDetailsLoading && <div className="h-v-center">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isStateReportingSessionDetailsLoadingFailed && <StatusCardComponent title={"Failed to load"}/>
                }
                {
                    isStateReportingSessionDetailsLoaded && <>
                        <CardComponent className={'view-details-header-wrapper'}>
                            <div className="card-content">
                                <div className="view-details-card-header-button-wrapper">
                                    <div className="view-details-card-title">
                                        {
                                            stateReportingSessionDetails?.panelDetails?.name
                                        }
                                    </div>
                                </div>
                                <div className="view-details-content">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Report Date"}>
                                                <div
                                                    className="view-details-value"> {commonService.formatDate(stateReportingSessionDetails?.reportingTime)} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Report Time"}>
                                                <div
                                                    className="details-value"> {commonService.formatTime(stateReportingSessionDetails?.reportingTime)} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Test Samples"}>
                                                <div
                                                    className="details-value"> {stateReportingSessionDetails?.sampleCount}</div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DetailsDataKeyValueComponent
                                                title={"Uploaded URL"}>
                                                <div
                                                    className="details-value">
                                                    <TooltipComponent
                                                        placement={'top'}
                                                        tooltip={stateReportingSessionDetails?.attachment?.url}
                                                        arrow={true}>
                                                        <div className="state-reporting-attachment-url">
                                                            {stateReportingSessionDetails?.attachment?.url}
                                                        </div>
                                                    </TooltipComponent>
                                                </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </CardComponent>
                        <div className="clear-fix"/>
                        <div className="send-outs-list-screen mrg-top-25 screen">
                            <div className={"screen-content-wrapper"}>
                                <div className="page-data-wrapper">
                                    <div className="page-data-wrapper t-table-inside-preview">
                                        <TableWrapperV2Component
                                            isPaginated={true}
                                            columns={Columns}
                                            url={APIConfig.STATE_REPORTING_SESSION_LIST.URL(sessionID)}
                                            method={APIConfig.STATE_REPORTING_SESSION_LIST.METHOD}
                                            isColumnFilterVisible={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>

            <DialogComponent open={showLogsPreviewDialog}
                             maxWidth={'md'}
                             title={`Attempt No. ${sessionData?.attempt}`}
                             isShowCancel={true}
                             onClose={() => {
                                 setShowLogsPreviewDialog(false)
                             }}
            >
                {sessionData?.responseData &&

                    <div className="session-logs-text-wrapper">
                        <pre>{JSON.stringify(sessionData?.responseData, null, 2)}</pre>
                    </div>
                }
                <DetailsDataKeyValueComponent title={"Report Date & Time:"} isHorizontal={true} >{commonService.formatDate(sessionData?.reportingTime)}
                    &nbsp;|&nbsp;
                    {commonService.formatTime(sessionData?.reportingTime)}
                </DetailsDataKeyValueComponent>
                <div className="pdd-top-10 d-flex justify-content-center">
                    {/*<ButtonComponent variant={"contained"}*/}
                    {/*                 color={"primary"}*/}
                    {/*                 id="continue_btn"*/}
                    {/*                 fullWidth={true}*/}
                    {/*                 handleClick={() => {*/}
                    {/*                     setShowLogsPreviewDialog(false)*/}
                    {/*                 }}*/}
                    {/*>*/}
                    {/*    close*/}
                    {/*</ButtonComponent>*/}
                    <CopyComponent content={JSON.stringify(sessionData?.responseData, null, 2)}/>
                </div>
            </DialogComponent>
        </div>
    );
};

export default StateReportingDetailsComponent;
